
import './side.less'
import { useState } from 'react'
import React from 'react'
import { Select } from 'antd'
import SelectB from '../selectorB/index.jsx'
import SelectB_Item from '../selectorB/item.jsx'
import 'antd/dist/antd.css'
import Card1 from './card1.jsx'
import Card2 from './card2.jsx'
import Card3 from './card3.jsx'
import Card4 from './card4.jsx'
console.log(React)
export default function SuspensionSide(props) {
  const [ifon, setIfon] = useState({
    options: [{ id: 0, text: '', src: 'https://read.e.qq.com/assets/images/yuebao/wxAttention-2.png' }, { id: 1, text: '', src: 'https://read.e.qq.com/assets/images/yuebao/wxAttention-1.png' }, { id: 2, text: '', src: 'https://read.e.qq.com/assets/images/yuebao/wxAttention-4.png' }, { id: 3, text: '', src: 'https://read.e.qq.com/assets/images/yuebao/wxAttention-3.png' }],
    list: [{ id: 0, text: '复制微信' }, { id: 1, text: '分享朋友圈' }]
  })
  console.log(setIfon)
  const cardStyle = props.ifon.card

  return (<div className='suspensionSide'>

    <h3 className='suspensionSide_title'>关注公众号</h3>

    <div className='suspensionSide_item'>
      <span className='item_title'>微信公众号</span>
      <div className='item_mainTransverse'>
        <Select placeholder='请输入公众号'
          showSearch
          bordered
          notFoundContent={'暂无数据'}
          style={{ width: '80%' }}
        >
          {/* <Option>123</Option> */}
        </Select>
        <span className='suaxin'>刷新</span>
      </div>
    </div>

    <div className='suspensionSide_item'>
      <span className='item_title'>样式</span>
      <div className='item_mainTransverse'>
        <SelectB options={ifon.options} id={props.ifon.card} onChange={(id) => {
          props.ifon.card = id
          props.mySetIfon(props.ifon)
        }}>
          {ifon.options.map((item) => {
            return <SelectB_Item id={item.id} key={item.id} >
              <img style={{ width: '100%', height: 45 }} src={item.src} />
            </SelectB_Item>
          })}
        </SelectB>
      </div>
    </div>

    {cardStyle === 0 && <Card1 ifon={props.ifon} mySetIfon={props.mySetIfon}></Card1>}

    {cardStyle === 1 && <Card2 ifon={props.ifon} mySetIfon={props.mySetIfon}></Card2>}

    {cardStyle === 2 && <Card3 ifon={props.ifon} mySetIfon={props.mySetIfon}></Card3>}

    {cardStyle === 3 && <Card4 ifon={props.ifon} mySetIfon={props.mySetIfon}></Card4>}

  </div >)
}

